export const SAVED_WORKFLOWS_KEY = 'bonzai-saved-workflows';
export const PUBLISHED_WORKFLOWS_KEY = 'bonzai-published-workflows';

export function getSavedWorkflows() {
  try {
    return JSON.parse(localStorage.getItem(SAVED_WORKFLOWS_KEY) || '[]');
  } catch { return []; }
}

export function deleteSavedWorkflow(id) {
  const saved = getSavedWorkflows().filter(w => w.id !== id);
  localStorage.setItem(SAVED_WORKFLOWS_KEY, JSON.stringify(saved));
}

export function renameSavedWorkflow(id, newName, newTimestamp) {
  const saved = getSavedWorkflows().map(w => w.id === id ? { ...w, name: newName, timestamp: newTimestamp || w.timestamp } : w);
  localStorage.setItem(SAVED_WORKFLOWS_KEY, JSON.stringify(saved));
}

export function saveWorkflowSnapshot(name, steps, timestamp, workflowId = null) {
  const saved = getSavedWorkflows();

  // If workflowId is provided, update existing workflow instead of creating new one
  if (workflowId) {
    const existingIndex = saved.findIndex(w => w.id === workflowId);
    if (existingIndex >= 0) {
      saved[existingIndex] = {
        ...saved[existingIndex],
        name,
        timestamp: timestamp || new Date().toISOString(),
        steps: JSON.parse(JSON.stringify(steps)),
      };
      localStorage.setItem(SAVED_WORKFLOWS_KEY, JSON.stringify(saved));
      return workflowId;
    }
  }

  // Otherwise create new workflow
  const newId = `wf-${Date.now()}`;
  saved.push({
    id: newId,
    name,
    timestamp: timestamp || new Date().toISOString(),
    steps: JSON.parse(JSON.stringify(steps)),
  });
  localStorage.setItem(SAVED_WORKFLOWS_KEY, JSON.stringify(saved));
  return newId;
}

export function getPublishedWorkflows() {
  try {
    return JSON.parse(localStorage.getItem(PUBLISHED_WORKFLOWS_KEY) || '[]');
  } catch { return []; }
}

export function recordPublishedWorkflow(name) {
  const published = getPublishedWorkflows();
  published.push({
    id: `pub-${Date.now()}`,
    name,
    timestamp: new Date().toISOString()
  });
  localStorage.setItem(PUBLISHED_WORKFLOWS_KEY, JSON.stringify(published));
}
